<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/component/overview/true']">Zur Übersicht</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!component">

  <!--<main>-->
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Komponente <cds-icon shape="two-way-arrows"></cds-icon> {{ technicalDrawing }}</h2>
  <button *ngIf="!component.active" class="btn btn-warning">PASSIV!</button>

  <div class="clr-row" >
    <div class="clr-col-12">
      <div class="card">
        <div class="card-header">
          Bezeichnung <cds-icon shape="two-way-arrows"></cds-icon> {{ component.name }}
        </div>
        <div class="card-block">
          <div class="card-text">
            <table class="table table-vertical">
              <tbody>
              <tr>
                <th>Kurzbeschreibung</th>
                <td>{{ component.description }}</td>
              </tr>
              <tr>
                <th>Spezifikation</th>
                <td>{{ component.specification }}</td>
              </tr>
              <tr>
                <th>Material</th>
                <td>{{ component.material_name }}</td>
              </tr>
              <tr>
                <th>Hersteller</th>
                <td>{{ component.manufacturer }}</td>
              </tr>
              <tr>
                <th>Richtpreis</th>
                <td>{{ component.guideline_price | currency: 'EUR':'code':'1.2-2':'de' }}</td>
              </tr>
              <tr>
                <th>Gewicht</th>
                <td>{{ component.weight }} kg</td>
              </tr>
              <tr>
                <th>Zolltarifnummer</th>
                <td *ngIf="component.taric && component.taric !== '0'">{{ component.taric }}</td>
                <td *ngIf="!component.taric || component.taric === '0'"></td>
              </tr>
              <tr>
                <th>Lagerbestand (Warehouse)</th>
                <td>
                  {{ component.number_of_pieces_in_stock }}
                  <br /><br />
                  <div class="btn-group btn-primary">
                    <button class="btn btn-primary btn-sm"  [routerLink]="['/warehouse/overview']" [queryParams]="{ drawing: technicalDrawing }">Bewegungen ansehen</button>
                    <button class="btn btn-primary btn-sm" (click)="oeffneInventur()" [disabled]="inventurOffen">Inventur</button>
                  </div>

                  <!-- Im Seitenfluss statt im Modal, wie "Datei fuer Komponente
                       hinzufuegen". Steht direkt unter dem Wert, den es aendert. -->
                  <div *ngIf="inventurOffen" class="inventur-block">
                    <h3>Inventur</h3>
                    <form class="clr-form" [formGroup]="inventurForm" *ngIf="inventurForm">

                      <clr-number-input-container>
                        <label>Gezählter Bestand</label>
                        <input clrNumberInput formControlName="counted_pieces" type="number" min="0" />
                        <clr-control-helper>Der tatsächlich gezählte Bestand, nicht die Abweichung.</clr-control-helper>
                        <clr-control-error *clrIfError="'required'">Bitte den gezählten Bestand eintragen.</clr-control-error>
                        <clr-control-error *clrIfError="'min'">Der Bestand kann nicht negativ sein.</clr-control-error>
                      </clr-number-input-container>

                      <clr-date-container>
                        <label>Datum der Zählung</label>
                        <input type="date" clrDate formControlName="date" />
                      </clr-date-container>

                      <clr-textarea-container>
                        <label>Bemerkung</label>
                        <textarea clrTextarea formControlName="comment" rows="2"></textarea>
                        <clr-control-helper>Optional, etwa der Grund einer Abweichung.</clr-control-helper>
                      </clr-textarea-container>

                      <div class="form-group">
                        <label>Beleg zur Zählung</label>
                        <div class="upload-row">
                          <label class="btn btn-sm btn-outline" for="inventur-upload">
                            <cds-icon shape="upload"></cds-icon> Datei wählen
                          </label>
                          <input id="inventur-upload" type="file" accept=".pdf,.jpg,.jpeg,.png"
                                 style="display:none" (change)="onInventurDatei($event)" />
                          <span class="upload-filename">{{ inventurDatei ? inventurDatei.name : '— keine Datei —' }}</span>
                        </div>
                      </div>
                    </form>

                    <p class="inventur-hinweis">
                      Gebucht wird die Abweichung zum bisherigen Bestand
                      ({{ component.number_of_pieces_in_stock ?? 0 }}). Stimmt die Zählung überein,
                      wird eine Buchung ohne Abweichung festgehalten — als Nachweis, dass gezählt wurde.
                    </p>

                    <div class="btn-group btn-primary btn-sm">
                      <button class="btn btn-primary"
                              [disabled]="inventurLaeuft || inventurForm?.invalid"
                              (click)="speichereInventur()">
                        {{ inventurLaeuft ? 'Wird gebucht …' : 'Inventur buchen' }}
                      </button>
                      <button class="btn btn-outline-info" [disabled]="inventurLaeuft"
                              (click)="inventurOffen = false">Abbrechen</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="stockSerials.length > 0">
                <th>Auf Lager (Seriennummern)</th>
                <td>
                  <table class="table stock-serials">
                    <thead>
                    <tr><th class="left">Seriennr.</th><th class="left">Charge</th><th class="left">Stück</th><th class="left">Letzte Bewegung</th><th class="left">Vorgang</th></tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let s of stockSerials">
                      <td class="left">{{ s.serial_nr || 'ohne Seriennummer' }}</td>
                      <td class="left">{{ s.heat_nr || '—' }}</td>
                      <td class="left">{{ s.number_of_pieces }}</td>
                      <td class="left">{{ movementLabel(s.last_movement_type) }} · {{ s.last_movement_date | date:'dd.MM.yyyy' }}</td>
                      <td class="left">
                        <a *ngIf="vorgangLink(s)" [routerLink]="vorgangLink(s)">{{ vorgangLabel(s) }}</a>
                        <span *ngIf="!vorgangLink(s)">—</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <th>Anhänge</th>
                <td>
                  <app-component-files [componentID]=technicalDrawing></app-component-files>
                  <app-component-parts [componentID]=technicalDrawing></app-component-parts>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-sm btn-link" (click)="editComponent(component)">Bearbeiten</button>
          <button *ngIf="countProjects === 0" class="btn btn-sm btn-link" (click)="deleteComponent(technicalDrawing, 1)">Löschen</button>
        </div>
      </div>
    </div>
  </div>

  <app-used-in-projects [componentId]=technicalDrawing></app-used-in-projects>
  <app-used-in-jobs  [componentId]=technicalDrawing></app-used-in-jobs>
  <app-used-in-orders  [componentId]=technicalDrawing></app-used-in-orders>
</main>
